import { styled, Typography } from '@mui/material';
import type { FC } from 'react';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import type {
  NetSuiteConfigurationControl,
  NetSuiteConfigurationFormValues,
} from '../../NetSuiteConfigurationFormSchema';
import { ControlledNetSuiteProductDropdown } from './ControlledNetSuiteProductDropdown';

type ProductsConfigurationSectionProps = {
  defaultValues: NetSuiteConfigurationFormValues;
  control: NetSuiteConfigurationControl;
};

export const ProductsConfigurationSection: FC<ProductsConfigurationSectionProps> = ({ 
  control,
}) => {
  return (
    <ConfigurationSection title="Products" iconName="Key">
      <ProductContainer>
        <Typography
          sx={{
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '12px',
          }}
        >
          Product Configuration
        </Typography>
        <ControlledNetSuiteProductDropdown
          control={control}
          fieldPath="defaultProduct"
          showDropdown={true}
          placeholder="Select NetSuite product for default configuration"
        />
      </ProductContainer>
    </ConfigurationSection>
  );
};

const ProductContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}); 